import { useContext } from 'react'

import { type AppInsightsContextType } from '../types/context'

import AppInsightsContext from '../context/AppInsightsContext'

export const useAppInsights = (): AppInsightsContextType => {
  const context = useContext(AppInsightsContext)

  if (!context) {
    throw new Error('useAppInsights must be used within an AppInsightsProvider')
  }

  return context
}
